import { ColumnDef } from '@tanstack/react-table';
import { CircleChevronRightIcon } from 'lucide-react';

import { useTranslation } from 'hooks';
import { IZipcodeInternacional } from 'interfaces/zipcode-internacional';
import { DataTableHelper } from 'utils';

import { translations } from './translations';

const dataTable = new DataTableHelper<IZipcodeInternacional>();

type HookOptions = {
  canEdit: boolean;
  onClickNavigateToDetails: (id: number) => void;
};

export const useZipcodeInternacionalColumns = ({
  canEdit,
  onClickNavigateToDetails,
}: HookOptions): ColumnDef<IZipcodeInternacional>[] => {
  const { getTranslation: t } = useTranslation(translations);

  const columns = [
    dataTable.buildColumn({
      enableSorting: false,
      id: t('code'),
      accessorKey: 'id',
      content: (row) => row.id,
    }),
    dataTable.buildColumn({
      enableSorting: false,
      id: t('country'),
      accessorKey: 'country',
      content: (row) => row.country?.description || "N/A",
    }),
    dataTable.buildColumn({
      enableSorting: false,
      id: t('zipcode'),
      accessorKey: 'zipcode',
      content: (row) => row.zipcode || '-',
    }),
    dataTable.buildColumn({
      enableSorting: false,
      id: t('city'),
      accessorKey: 'city',
      content: (row) => row.city || '-',
    }),
    dataTable.buildColumn({
      enableSorting: false,
      id: t('state'),
      accessorKey: 'state',
      content: (row) => row.state || '-',
    }),
    dataTable.buildColumn({
      enableSorting: false,
      id: t('neighborhood'),
      accessorKey: 'neighborhood',
      content: (row) => row.neighborhood || '-',
    }),
    dataTable.buildColumn({
      enableSorting: false,
      id: t('street'),
      accessorKey: 'street',
      content: (row) => row.street || '-',
    }),
  ];

  if (!canEdit) {
    return columns;
  }

  const navigationButton = dataTable.buildColumn({
    enableSorting: false,
    enableHiding: true,
    id: 'Open details',
    title: '',
    accessorFn: (row) => `open-details-${row.id}`,
    content: (row) => (
      <div className="flex flex-row items-center">
        <button
          className="ml-auto"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onClickNavigateToDetails(row.id);
          }}
        >
          <CircleChevronRightIcon />
        </button>
      </div>
    ),
  });

  return [...columns, navigationButton];
};
